export const transformPrismicImageUrl = (url: string, width: number) => {
  const imageURL = new URL(url);
  imageURL.searchParams.delete('w');
  imageURL.searchParams.delete('h');

  imageURL.searchParams.delete('width');
  imageURL.searchParams.delete('height');

  imageURL.searchParams.set('width', width.toString());

  return imageURL.toString();
};
